/*
  Crop an image to the given pixel rectangle (from react-easy-crop).

  With `round: true` (default) the result is masked into a circle and returned
  as a PNG so the corners are transparent — ideal for avatars. Otherwise a
  square JPEG is produced. Works with object-URL sources (no CORS issues).
*/
export const getCroppedImg = (imageSrc, pixelCrop, { round = true } = {}) =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.src = imageSrc;

    image.onload = () => {
      const canvas = document.createElement('canvas');
      const size = Math.round(Math.min(pixelCrop.width, pixelCrop.height));
      canvas.width = round ? size : Math.round(pixelCrop.width);
      canvas.height = round ? size : Math.round(pixelCrop.height);

      const ctx = canvas.getContext('2d');

      ctx.drawImage(
        image,
        pixelCrop.x,
        pixelCrop.y,
        canvas.width,
        canvas.height,
        0,
        0,
        canvas.width,
        canvas.height
      );

      if (round) {
        /* Keep only the pixels inside the circle → transparent corners */
        ctx.globalCompositeOperation = 'destination-in';
        ctx.beginPath();
        ctx.arc(
          canvas.width / 2,
          canvas.height / 2,
          canvas.width / 2,
          0,
          Math.PI * 2
        );
        ctx.closePath();
        ctx.fill();
        ctx.globalCompositeOperation = 'source-over';
      }

      canvas.toBlob(
        (blob) => {
          if (!blob) {
            reject(new Error('Canvas is empty'));
            return;
          }
          resolve(blob);
        },
        round ? 'image/png' : 'image/jpeg',
        round ? undefined : 0.9
      );
    };

    image.onerror = () => reject(new Error('Failed to load image'));
  });

export default getCroppedImg;
